import React, { FunctionComponent } from 'react';
import { SharedIconInfo } from '../../icons/shared-icon-info';
import {
  IconButton,
  PopoverTrigger,
  Popover,
  PopoverContent,
  PopoverBody,
  PopoverCloseButton,
  PopoverHeader
} from '@chakra-ui/react';

interface AppPopOverProps {
  title?: string;
  text: string;
  variant?: 'blue';
}

export const AppPopOver: FunctionComponent<AppPopOverProps> = ({ title, text, variant }) => {
  return (
    <Popover variant={variant}>
      <PopoverTrigger>
        <IconButton
          tabIndex={-1}
          bgColor={'transparent'}
          _hover={{ bgColor: 'gray.100' }}
          mb={1}
          w={`fit`}
          p={0}
          icon={<SharedIconInfo color={`blue.500`} boxSize={8} />}
          aria-label="meer informatie"></IconButton>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverCloseButton />
        {title && <PopoverHeader>{title}</PopoverHeader>}
        <PopoverBody dangerouslySetInnerHTML={{ __html: text }}></PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
